import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BuildingConfig, Restriction } from '@cobu/types';

export interface SettingsState {
  buildingConfig: BuildingConfig | null;
  chatPollingEnabled: boolean;
  tooltipPollingEnabled: boolean;
  restriction: Restriction | null;
}

const initialState: SettingsState = {
  buildingConfig: null,
  chatPollingEnabled: false,
  tooltipPollingEnabled: false,
  restriction: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setBuildingConfig: (state, action: PayloadAction<BuildingConfig | null>) => {
      state.buildingConfig = action.payload;
    },
    saveChatPollingFeatureFlag: (state, action: PayloadAction<boolean>) => {
      state.chatPollingEnabled = action.payload;
    },
    saveTooltipPollingFeatureFlag: (state, action: PayloadAction<boolean>) => {
      state.tooltipPollingEnabled = action.payload;
    },
    setRestriction: (state, action: PayloadAction<Restriction | null>) => {
      state.restriction = action.payload;
    },
    clearSettings: () => initialState,
  },
});

export const { 
  setBuildingConfig, 
  saveChatPollingFeatureFlag, 
  saveTooltipPollingFeatureFlag,
  setRestriction,
  clearSettings
} = settingsSlice.actions;

export default settingsSlice.reducer;

export const selectBuildingConfig = (state: { settings: SettingsState }) => state.settings.buildingConfig;

